<template>
  <div class="job-board-point-dashboard-container">
    <div class="header-container">
      <span class="name-label">{{ $t(`${i18nPrefix}.title.index`) }}</span>
      <div class="filter-container">
        <el-select
          class="select company-select"
          v-model="companySelect"
          multiple
          filterable
          collapse-tags
          clearable
          @change="handelCompanySelectChange"
          @visible-change="handelCompanySelectVisibleChange"
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.i18nName"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select
          class="select channel-select"
          v-model="channelType"
          @change="handelChange"
        >
          <el-option
            v-for="item in channelList"
            :key="item.key"
            :label="item.i18nName"
            :value="item.key">
          </el-option>
        </el-select>
      </div>
    </div>
    <TableList
      v-loading="showLoading"
      class="table-container"
      :listData="listData"
      :defaultExpandAll="false"
      :tableColumns="tableColumns"
      no-operation
    >
      <template #btn-group>
        <div></div>
      </template>
      <template #points="{ row }">
        <div class="points-container">
          <span class="points">{{ row.points | formatBigNumber }}</span>
          <i class="transfer-icon iconfont iconEditor1" @click="handelRechargeDialog(row)"/>
          <i class="history-icon iconfont iconHistory1" @click="handelToHistory(row)"/>
        </div>
      </template>
      <template #count="{ row }">
        <div class="count-container">
          <span class="count-label">{{ (row.max_count || channelDefaultCountForLinkedin) | formatBigNumber }}</span>
          <i class="iconfont iconEditor1" @click="handelMaxCountDialog(row)"/>
        </div>
      </template>
    </TableList>
    <div class="pagination-container">
      <el-pagination
        class="pagination"
        background
        :current-page="pageSetting.currentPage"
        layout="prev, pager, next"
        :total="pageSetting.total"
        :page-size="pageSetting.pageSize"
        @current-change="handelPageChange"
        >
      </el-pagination>
    </div>
    <DialogWrapper
      closeOnCancel
      destroyOnClose
      :show.sync="rechargeDialog.show"
      :closeOnClickModal="false"
      @save="handelRechargePoints"
      >
      <div class="interior-points-transfer">
        <span class="title">{{ $t(`${i18nPrefix}.label.surplusPointsTitle`, { companyName: rechargeDialog.title}) + ' ' + formatBigNumber(rechargeDialog.points) }}</span>
        <div class="operate-container">
          <div class="type-select">
            <span :class="rechargeDialog.type === '+' && 'select'" @click="rechargeDialog.type = '+'"><i class="el-icon-plus"/></span>
            <span :class="rechargeDialog.type === '-' && 'select'" @click="rechargeDialog.type = '-'"><i class="el-icon-minus"/></span>
          </div>
          <div class="info-container">
            <el-input
              class="input number-input points-input"
              :value="rechargeDialog.operatePoints"
              :placeholder="$t(`${i18nPrefix}.placeholder.pointsInput`)"
              @input="handelOperatePointsChange"
              >
            </el-input>
            <el-input class="input note-input" :placeholder="$t(`${i18nPrefix}.placeholder.notes`)" v-model="rechargeDialog.note"></el-input>
            <span class="tips" v-show="rechargeDialog.showTips">{{ $t(`${i18nPrefix}.message.pointsRequired`) }}</span>
            <span class="tips" v-show="rechargeDialog.showLessThanMillionTips">{{ $t(`${i18nPrefix}.message.pointsLessThanMillion`) }}</span>
          </div>
        </div>
      </div>
      <Loading class="loading" v-show="rechargeDialog.loading"/>
    </DialogWrapper>
    <DialogWrapper
      closeOnCancel
      destroyOnClose
      :show.sync="maxCountDialog.show"
      :closeOnClickModal="false"
      @save="saveMaxCount"
      >
      <div class="max-count-container">
        <span class="title">{{ maxCountDialog.title }}</span>
        <div class="operate-container">
          <span class="max-count-label">{{ $t(`${i18nPrefix}.label.purchasedJobsCount`) }}</span>
          <el-input class="number-input" type="number" v-model="maxCountDialog.count"></el-input>
        </div>
        <span class="tips" v-show="maxCountDialog.showTips">{{ $t(`${i18nPrefix}.message.maxCountGatherZero`) }}</span>
      </div>
      <Loading class="loading" v-show="maxCountDialog.loading"/>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { addI18nProperty } from '@/i18n'
import { mapActions } from 'vuex'
import TableList from '../../components/jobBoardPoint/table.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import Loading from '@/components/loading/rectLoading.vue'
import { channelDefaultCountForLinkedin } from '@/constant/company'
import { formatBigNumber } from '@/components/filters'

const defaultChannel = 'ajinga'
const pointChannel = '51job'
const countChannel = 'linkedin'

export default {
  components: {
    TableList,
    DialogWrapper,
    Loading
  },
  data () {
    return {
      channelDefaultCountForLinkedin,
      formatBigNumber,
      i18nPrefix: 'admin.company.jobBoardPointDashboard',
      listData: [],
      channelType: '',
      channelList: [],
      companySelectChange: false,
      companySelect: [],
      companyList: [],
      showLoading: false,
      rechargeDialog: {
        show: false,
        loading: false,
        title: '',
        points: '',
        companyId: '',
        operatePoints: '',
        note: '',
        type: '+',
        showTips: false,
        showLessThanMillionTips: false
      },
      pageSetting: {
        currentPage: 1,
        total: 0,
        pageSize: 10
      },
      maxCountDialog: {
        show: false,
        loading: false,
        title: '',
        count: '',
        companyId: '',
        showTips: false
      }
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          dataKey: this.isEn ? 'name' : 'cn_name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.companyID`),
          dataKey: 'id'
        }
      ]
      if (!this.channelType || this.channelType === pointChannel) {
        columns.push({
          label: this.$t(`${this.i18nPrefix}.label.allocatePoints`),
          dataKey: 'points',
          slotName: 'points'
        })
      }
      columns.push({ label: this.$t(`${this.i18nPrefix}.label.${this.channelType === countChannel ? 'activeJobs' : 'postingJobs'}`), dataKey: 'posting_count' })
      if (this.channelType === countChannel) {
        columns.push({
          label: this.$t(`${this.i18nPrefix}.label.purchasedJobsCount`),
          dataKey: 'count',
          slotName: 'count'
        })
      }
      return columns
    }
  },
  async created () {
    await this.initJobChannel()
    await this.initCompanyList()
    await this.initListData()
  },
  mounted () {
  },
  methods: {
    ...mapActions('company', ['getClientJobBoardPointDashboardList', 'getCompanyJobPostingChannelList', 'rechargeJobPostingPoints', 'changeJobPostingMaxCount']),
    ...mapActions('superAdmin', ['getSuperAdminCompanyList']),
    async initListData () {
      this.showLoading = true
      try {
        const params = {
          page: this.pageSetting.currentPage,
          page_size: this.pageSetting.pageSize,
          channel_key: this.channelType || defaultChannel,
          company_ids: this.companySelect.join(',')
        }
        const resp = await this.getClientJobBoardPointDashboardList(params)
        if (resp && resp.company_list) {
          this.listData = resp.company_list
          this.pageSetting.total = resp.total
        }
      } finally {
        this.showLoading = false
      }
    },
    async initJobChannel () {
      const channelType = this.$route.query.channelType
      await this.getCompanyJobPostingChannelList({ all_channels: true }).then(resp => {
        if (resp && resp.post_channels) {
          this.channelList = _.map(resp.post_channels, channel => {
            addI18nProperty(channel, 'i18nName', 'cn_name', 'name')
            return channel
          })
          this.channelType = defaultChannel
          if (channelType && _.find(this.channelList, 'key', channelType)) {
            this.channelType = channelType
          }
        }
      })
    },
    async initCompanyList () {
      const companyIdsStr = this.$route.query.companyIds
      const params = {
        point_management: 1,
        only_root_company: 1
      }
      await this.getSuperAdminCompanyList(params).then(resp => {
        if (resp && resp.result) {
          this.companyList = _.map(resp.result, company => {
            addI18nProperty(company, 'i18nName', 'cn_name', 'name')
            return company
          })
          if (companyIdsStr) {
            this.companySelect = _.map(companyIdsStr.split(','), (item) => _.toNumber(item))
          }
        }
      })
    },
    handelRechargeDialog (row) {
      this.rechargeDialog.title = row[this.isEn ? 'name' : 'cn_name']
      this.rechargeDialog.points = row.points
      this.rechargeDialog.companyId = row.id
      this.rechargeDialog.operatePoints = ''
      this.rechargeDialog.note = ''
      this.rechargeDialog.type = '+'
      this.rechargeDialog.showTips = false
      this.rechargeDialog.showLessThanMillionTips = false
      this.rechargeDialog.show = true
    },
    handelCompanySelectChange () {
      this.companySelectChange = true
    },
    handelCompanySelectVisibleChange (visible) {
      if (!visible && this.companySelectChange) {
        this.companySelectChange = false
        this.$router.push({ path: this.$router.path, query: { ...this.$route.query, companyIds: this.companySelect.join(',') } })
        this.handelPageChange(1)
      }
    },
    handelChange () {
      this.$router.push({ path: this.$router.path, query: { ...this.$route.query, channelType: this.channelType } })
      this.handelPageChange(1)
    },
    handelPageChange (page) {
      this.pageSetting.currentPage = page
      this.initListData()
    },
    handelOperatePointsChange (value) {
      const number = value?.replace(/[^0-9]/g, '')
      this.rechargeDialog.operatePoints = number && formatBigNumber(_.replace(number.toString(), /,/g, ''))
    },
    handelToHistory (row) {
      this.$router.push({ name: 'clientAdminJobBoardPointDashboardHistory', params: { companyId: row.id }, query: this.$route.query })
    },
    async handelRechargePoints () {
      const rechargeDialog = this.rechargeDialog
      if (this.channelType !== pointChannel) {
        rechargeDialog.show = false
        return
      }
      rechargeDialog.showTips = false
      rechargeDialog.loading = true
      if (!rechargeDialog.operatePoints || rechargeDialog.operatePoints <= '0') {
        rechargeDialog.showTips = true
        rechargeDialog.showLessThanMillionTips = false
        rechargeDialog.loading = false
        return
      }
      if (rechargeDialog.type === '-' && rechargeDialog.operatePoints > rechargeDialog.points) {
        rechargeDialog.showTips = true
        rechargeDialog.showLessThanMillionTips = false
        rechargeDialog.loading = false
        return
      }
      if (rechargeDialog.type === '+' && (rechargeDialog.operatePoints + rechargeDialog.points) > 1000000) {
        rechargeDialog.showLessThanMillionTips = true
        rechargeDialog.showTips = false
        rechargeDialog.loading = false
        return
      }
      const params = {
        points: _.chain(rechargeDialog.operatePoints).replace(/[,']/g, '').toNumber().value(),
        note: rechargeDialog.note,
        action: rechargeDialog.type === '+' ? 'add' : 'subtract',
        channel_key: this.channelType,
        target_company_id: rechargeDialog.companyId
      }
      try {
        const resp = await this.rechargeJobPostingPoints(params)
        if (resp && resp.message) {
          if (resp.message === 'success') {
            this.initListData()
            rechargeDialog.show = false
          } else {
            this.$message.error('error')
          }
        }
      } finally {
        rechargeDialog.loading = false
        rechargeDialog.showTips = false
      }
    },
    handelMaxCountDialog (row) {
      this.maxCountDialog.title = row[this.isEn ? 'name' : 'cn_name']
      this.maxCountDialog.companyId = row.id
      this.maxCountDialog.count = row.max_count || channelDefaultCountForLinkedin
      this.maxCountDialog.showTips = false
      this.maxCountDialog.show = true
    },
    async saveMaxCount () {
      const maxCountDialog = this.maxCountDialog
      if (this.channelType !== countChannel) {
        maxCountDialog.show = false
        return
      }
      maxCountDialog.showTips = false
      maxCountDialog.loading = true
      if (maxCountDialog.count < 0) {
        maxCountDialog.showTips = true
        maxCountDialog.loading = false
        return
      }
      const params = {
        channel_key: this.channelType,
        company_id: maxCountDialog.companyId,
        count: maxCountDialog.count
      }
      try {
        const resp = await this.changeJobPostingMaxCount(params)
        if (resp && resp.message) {
          if (resp.message === 'success') {
            this.initListData()
            maxCountDialog.show = false
          } else {
            this.$message.error('error')
          }
        }
      } finally {
        maxCountDialog.loading = false
        maxCountDialog.showTips = false
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.job-board-point-dashboard-container {
  background: #FFFFFF;
  padding: 30px;

  .header-container {
    margin-bottom: 20px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name-label {
      width: 240px;
      font-size: 16px;
    }
    .filter-container {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;

      .select {
        width: 30%;
      }
      .channel-select {
        margin-left: 30px;
      }
    }
  }
  .table-container {

    .points-container {
      display: flex;
      align-items: center;
      .points {
        display: inline-flex;
        min-width: 45px;
        line-height: 1;

        &.root {
          margin-right: 17px;
        }
      }

      .history-icon {
        margin-left: 5px;
      }

    }

    .iconfont {
      cursor: pointer;
      color: #0096CC;
      font-size: 18px;
      line-height: 1;
    }

    .count-container {
      display: flex;
      align-items: center;

      .count-label {
        margin-right: 10px;
        font-size: 14px;
        line-height: 1;
      }
    }
  }
  .interior-points-transfer {

    .title {
      font-size: 22px;
      color: #303133;
    }

    .operate-container {
      margin-top: 30px;
      text-align: center;
      display: flex;
      justify-content: flex-start;

      .type-select {
        display: flex;
        color: #606266;
        margin-right: 20px;

        > span {
          width: 32px;
          height: 32px;
          font-size: 18px;
          line-height: 32px;
          border: 1px solid #E4E7ED;
          border-radius: 2px;
          cursor: pointer;

          > i {
            font-weight: bold;
          }

          &:first-child {
            margin: 0;
            line-height: 30px;
          }
        }

        .select {
          color: #0096cc;
        }
      }
    }

    .info-container {
      text-align: left;
      .input {
        margin-bottom: 15px;
      }

      .tips {
        color: #ff0000;
      }
    }
  }
  .max-count-container {
    padding-bottom: 20px;

    .title {
      font-size: 22px;
      color: #303133;
    }

    .operate-container {
      margin-top: 30px;
      display: flex;
      align-items: center;
      font-size: 16px;

      .max-count-label {
        word-break: keep-all;
        white-space: nowrap;
      }

      .number-input {
        margin-left: 20px;
      }
    }

    .tips {
      margin-left: 35%;
      color: #ff0000;
    }
  }

  .pagination-container {
    padding-top: 20px;
    text-align: center;
  }

  .loading {
    position: absolute;
  }
  ::v-deep {
    .table-header {
      display: none;
    }
    .number-input {
      ::-webkit-inner-spin-button,
      ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    .el-select {
      &.select {
        .el-input__inner {
          color: #909399;
          border-radius: 2px;
        }
      }
    }
    .el-table {
      border-color: #DFDFDF;
      &::after {
        background-color: #DFDFDF;
      }
      &::before {
        background-color: #DFDFDF;
      }
      .el-table__header-wrapper {
        .el-table__cell {
          background: #FAFAFA;
          border-color: #DFDFDF;
        }
      }
      .el-table__body {
        border-color: #DFDFDF;
        .el-table__cell {
          border-color: #DFDFDF;
        }
      }
    }
    .el-dialog {
      width: 40%;
    }
  }
}
</style>
